<template>
    <div class="container card">

        <nav class="level is-mobile">
						<div class="level-left">
						</div>
						<div class="level-right">
                            <div class="level-item">
							<b-button size="is-small"
                                    icon-left="close"
                                    v-if="selected"
                                    @click="selected = null">
                                    clear selection
                                </b-button>
							</div>
							<div class="level-item">
                                <b-button size="is-small"
                                        icon-left="plus"
                                        @click="showAddResultBlParasite"
                                        >
                                        Add new
                                    </b-button>
							</div>

                            <div class="level-item">
                                <b-button size="is-small"
                                        icon-left="close"
                                        type="is-danger"
                                        @click="$emit('close')"
                                        >
                                         
                                    </b-button>
							</div>



						</div>
					</nav>





             <b-table
                                    :data="isEmpty ? [] : dataBlParasiteResMst"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    :loading="isTblLoading"
                                    :selected.sync="selected"
                                    mobile-cards>
                                <b-table-column   label="Result Available"  v-slot="props"  width="40%">
                                    <!-- {{ props.row.data_res }} -->
                                        <b-taglist>
                                            <b-tag type="is-info is-light" 
                                                   size="is-medium" 
                                                   v-for="dataRes in props.row.data_res.id "  
                                                   :key="dataRes">
                                                {{dataRes}}
                                            </b-tag>
                                        </b-taglist>
                                </b-table-column>
             </b-table>    
             <!-- {{selected}}                -->


               <AddResultBlParasite
                        v-if="isAddResultBlParasiteShowing"
                        @close="closeAddResultBlParasite"
                        @closeWithDataChange = "closeAddResultBlParasite_WithChange"
                    />

    </div>
</template>


<script>
import axios from "axios";
import { getBaseURLforBackEnd ,getConfigAxios  }  from '@/utils.js'
import { mapState } from "vuex";
import AddResultBlParasite from '../BloodParasite/AddResultBlParasite.vue'


export default {
    name : "ResultBloodParasiteMaster",
    components:{
        AddResultBlParasite ,
    },
    mounted(){
        // console.log("mounted  ResultBloodParasiteMaster")
        this.loadData()
    },
    computed:{
          ...mapState({
                access_token : state => state.master_data.access_token,
            }) ,
             
    },
    methods:{
        //********************************************************* */ 
        showAddResultBlParasite(){
            this.isAddResultBlParasiteShowing = true
        },
        closeAddResultBlParasite(){
            this.isAddResultBlParasiteShowing = false
        },
        closeAddResultBlParasite_WithChange(){
            this.isAddResultBlParasiteShowing = false
            this.loadData()
        },  

        //********************************************************* */   
        loadData(){
                this.isTblLoading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/list_of_result_blparasite_master`,getConfigAxios())
                    .then((res)=>{
                        this.dataBlParasiteResMst = res.data
                        this.isTblLoading = false
                    })
                    .catch((err)=>{
                        this.isTblLoading = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        this.$router.push('/login')
                            .catch(()=>{});
                    })  
        }
    },

    data() {
            return {
               dataBlParasiteResMst : [],
               isEmpty : false,
               isTblLoading : false,
               selected : null,

               isAddResultBlParasiteShowing : false,
            }
    },
    watch:{
        selected:{
            immediate: true,
            handler: function(val){
                if(val){
                    this.$emit('newSelected',val)
                }
            }
        }
    }
}
</script>

<style scoped>

 /* div {
  background-color: lightblue;
} */


</style>